import React from 'react';
import {styled} from '@mui/material/styles';
import {DefaultToastContainer} from 'react-toast-notifications';


const StyledToastContainer = styled(DefaultToastContainer)(({theme}) => ({
    zIndex: '5000 !important',
    paddingTop: theme.mixins.toolbar.minHeight,
}));

export default function MUIToastContainer({ children, ...otherProps }) {

    return (
        <StyledToastContainer {...otherProps}>
            {children}
        </StyledToastContainer>
    );
}

MUIToastContainer.defaultProps = {

};
